import React from 'react';
import { Space } from 'antd';

import checkGreen from '../../../../assets/icons/checkGreen.svg';
import checkGreenChecked from '../../../../assets/icons/checkGreenChecked.svg';
import checkRedClose from '../../../../assets/icons/checkRedClose.svg';
import checkRedChecked from '../../../../assets/icons/checkRedChecked.svg';
import colors from '../../../../styles/colors';

export function ExtraCollapse({
  idEStatus,
  handlerAprovar = () => {},
  handlerReprovar = () => {},
}) {
  return (
    <Space onClick={event => event.stopPropagation()}>
      <button
        type="button"
        aria-label="Aprovar consulta"
        onClick={handlerAprovar}
        style={{
          padding: 0,
          border: 0,
          background: 'transparent',
          marginRight: '10px',
          cursor: 'pointer',
        }}
      >
        <img
          src={idEStatus.status === 7 ? checkGreenChecked : checkGreen}
          alt=""
          style={{
            display: 'block',
            fontSize: '24px',
            color: colors.verde,
            fontWeight: 'normal',
          }}
        />
      </button>

      <button
        type="button"
        aria-label="Reprovar consulta"
        onClick={handlerReprovar}
        style={{
          padding: 0,
          border: 0,
          background: 'transparent',
          marginRight: '40px',
          cursor: 'pointer',
        }}
      >
        <img
          src={idEStatus?.status === 6 ? checkRedChecked : checkRedClose}
          alt=""
          style={{
            display: 'block',
            fontSize: '24px',
            color: colors.vermelho,
            fontWeight: 'normal',
          }}
        />
      </button>
    </Space>
  );
}
